"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ethnicityFactory = void 0;
const Factory = require("factory.ts");
const Mocks = require("../../../mocks");
exports.ethnicityFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    code: '999',
    name: 'Alien',
    created_at: Mocks.dates.date2000,
    updated_at: Mocks.dates.date2000
});
